import { THEMES, useTheme } from '../lib/theme';

export function ThemePicker() {
  const { theme, setTheme } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}
    >
      {THEMES.map(t => (
        <div
          key={t.k}
          role="radio"
          aria-checked={theme === t.k}
          tabIndex={0}
          className={`swatch ${theme === t.k ? 'swatch--active' : ''}`}
          data-t={t.k}
          onClick={() => setTheme(t.k)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setTheme(t.k);
            }
          }}
        >
          <span className="dot" style={{ background: t.dot }} />
          {t.label}
        </div>
      ))}
    </div>
  );
}
